import { Color } from "three"
import type { NeighborWeights } from "./NeighborWeights.type"

/**
 * RGB colors for 8 neighbors (in eightDirections order), plus the base.
 */
export type NeighborColors = {
  base: Color
  list: ReadonlyArray<Readonly<Color>> // length === 8
}

/**
 * Calculates the weighted average color for a tile position based on weights.
 * 
 * @param weights - Weights computed from a normalized (x, y) point
 * @param colors - Colors for the base and neighbors
 * @param out - Optional output Color to avoid allocations
 * @returns the interpolated color
 */
export default function calculateNodeVertexOutputColor(
  weights: NeighborWeights,
  colors: NeighborColors,
  out: Color = new Color(),
): Color {
  const { base: wBase, list: wList, total } = weights
  const { base: cBase, list: cList } = colors

  let r = wBase * cBase.r
  let g = wBase * cBase.g
  let b = wBase * cBase.b

  for (let i = 0; i < 8; i++) {
    const w = wList[i]
    const c = cList[i]
    r += w * c.r
    g += w * c.g
    b += w * c.b
  }

  const d = total > 0 ? total : 1
  return out.setRGB(r / d, g / d, b / d)
}
